<div class='full-form full-form-wide'>
  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetACS.ready.value) {
    <div class='mt-24'>
      <dataset-list
        #tripList
        datasetCode='actual_trips'
        [parentDatasetRS]='datasetRS'
        [parentDatasetACS]='datasetACS'
        [showSearchBar]='true'
        [elevate]='false'
        [emitAdd]='true'
        [addButtonText]='"Genera"'
        [filters]='{ trip_package_id: datasetRS.recordId, start_day: todayFilter }'
        (add)='generate()'
      ></dataset-list>
    </div>
  }
</div>